import React from "react";
import { View, Text } from "@react-pdf/renderer";

const pdfLegend = ({ data_list, colors }) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        marginVertical: 5,
      }}
    >
      {data_list &&
        data_list.map((d, i) => (
          <View
            key={i}
            style={{
              display: "flex",
              flexDirection: "row",
              marginRight: 5,
              alignItems: "center",
            }}
          >
            <Text
              style={{
                backgroundColor: colors[i],
                borderRadius: 50,
                width: 6,
                height: 6,
                paddingRight: 4,
              }}
            >
              0
            </Text>
            <Text
              style={{
                fontSize: 8,
                color: "#333333",
                marginLeft: 2,
                marginRight: 2,
              }}
            >{`${d}`}</Text>
          </View>
        ))}
    </View>
  );
};

export default pdfLegend;



// WEBPACK FOOTER //
// ./src/components/parts/pdfmaker/common/pdfLegend.jsx